/* globals */
import ObservabilityProvider from '.'

export default ObservabilityProvider.setup()
